<script lang="ts">
  import { xhr, toast } from "$app/utils"
  import Button from "$app/components/ButtonSpinner.svelte"
  import Navigation from "./Navigation.svelte"
  import { appStore } from "$app/store.svelte"

  import bg from "@images/onboarding/bg-eclipse.jpg"
  import app_store from "@images/onboarding/app-store.png"
  import google_play from "@images/onboarding/google-play.png"
  import mobile_app from "@images/onboarding/mobile-app.png"

  let { onUpdateStep, onUpdateUser } = $props()

  let errors = $state({})

  let saving = $state(false)
  async function updateUser() {
    saving = true
    errors = {}
    const formData = new FormData()
    formData.append("user[onboarding_steps][mobile_app]", "true")
    try {
      const resp = await xhr.patch(
        `/user_onboarding/${appStore.current_user.id}`,
        formData
      )
      onUpdateUser(resp.data)
    } catch (e) {
      console.error(e.response)
      toast("There was an error", "error")
      if (e.response) {
        errors = { ...errors, ...e.response.data.errors }
      }
    } finally {
      saving = false
    }
  }
</script>

<div class="w-full">
  <div class="px-4 lg:px-6 pt-4 w-full pb-8 lg:pb-12 lg:text-left">
    <Navigation step="mobile_app" {onUpdateStep} />
  </div>
  <div class="relative">
    <div class="mx-auto px-2 lg:px-6 w-full pb-8 lg:pb-20 lg:text-left">
      <div class="px-4 w-full lg:w-1/2 xl:w-5/12 xl:pr-16">
        <h2 class="text-3xl md:text-4xl font-bold text-left text-white">
          Download Lead With Purpose Mobile App
        </h2>

        <p class="mt-4 md:mt-6 text-lg text-white">
          To get the most from Lead with Purpose, download and install the Lead
          With Purpose App from either the App Store or the Google Play store.
        </p>
        <p class="mt-2 md:mt-8 text-lg text-white">
          The Lead With Purpose Mobile App will give you access to the key
          functionality and allow you to receive push notifications to stay on
          top of the latest activity for your plan.
        </p>

        <div class="flex justify-center items-center gap-x-5 mt-6 lg:mt-12">
          <a
            href="https://apps.apple.com/us/app/lead-with-purpose/id1600163569"
            target="_blank"
            aria-label="Download on the App Store"
          >
            <img
              src={app_store}
              class="w-auto h-16"
              alt="Download on the App Store"
            />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.leadwithpurpose.lwpMobile"
            target="_blank"
            aria-label="Get it on Google Play"
          >
            <img
              src={google_play}
              class="w-auto h-16"
              alt="Get it on Google Play"
            />
          </a>
        </div>

        <div class="relative w-full block lg:hidden mt-6 md:mt-12">
          <img
            src={mobile_app}
            class="mx-auto w-56 h-auto"
            alt="Mobile App Screenshot"
          />
        </div>

        <div
          class="space-y-8 mt-4 lg:mt-8 max-w-md mx-auto flex justify-center"
        >
          <Button
            onclick={updateUser}
            processing={saving}
            class="btn-rounded bg-green-600 hover:bg-green-700 text-white btn-big w-full text-lg font-bold md:w-60 h-14"
          >
            Continue
          </Button>
        </div>
      </div>
    </div>
    <div
      class="hidden lg:inline-block lg:absolute lg:inset-y-0 lg:-right-0 lg:w-1/2 xl:w-7/12 lg:h-full bg-lwp-light-grey bg-right-bottom bg-no-repeat bg-contain"
      style="background-image: url({bg});"
    >
      <img
        src={mobile_app}
        class="relative mt-6 mx-auto w-64 h-auto shadow-lg border border-gray-300"
        alt="Mobile App Screenshot"
      />
    </div>
  </div>
</div>
